import React, { PureComponent } from 'react';
import {
	ThankWrapper,
	Title,
	Message,
} from './thankYouStyles';
import PropTypes from 'prop-types';

import {
	Button,
} from './signupFormStyles';

class Errored extends PureComponent {
	render () {
		const { errorOnClickBtn } = this.props;
		return (
			<ThankWrapper>
				<Title>Oh No! 😢</Title>
				<Message>Something went bad on our end.</Message>
				<Message>Please contact support or</Message>
				<Button onClick={errorOnClickBtn}>Try Again</Button>
			</ThankWrapper>
		);
	}

	static propTypes = {
		errorOnClickBtn: PropTypes.func,
	}
}

export default Errored;
